<template>
  <div>
    <div class="Topic-title">已订阅 Topic 列表</div>
    <!-- <div>
      <v-input
        class="ml10"
        v-model="searchData"
        :placeholder="placeholder"
        suffix-icon="v-icon-search"
        @change="searchdata"
      ></v-input>
    </div> -->
    <div class="mt10">

      <vxe-table border row-id="id" :data="TopicList" align="left">
      <vxe-table-column type="seq" show-overflow width="50" title="序号" ></vxe-table-column>
        <vxe-table-column
          field="Topic"
          show-overflow
          min-width="520"
          title="设备的 Topic"
        ></vxe-table-column>

      </vxe-table>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    devName: {},
    devId: {},
    devKey: {},
  },
  data() {
    return {
      activeNamebutton: "",
      searchData: "",
      placeholder: "请输入 Topic",
      TopicList: [],
    };
  },
  created() {
    this.getData()
  },

  methods: {
    searchdata() {},
    async getData() {
      const subData = {
        dev_key: this.devKey,
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$post("/td/td-iot-api/iot/dev/sub/v1", subData, false);
      if (res.code === 0) {
        this.TopicList = res.data.length ? res.data : []
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
